import React, { useState, useEffect } from 'react'
import { useHistory } from "react-router-dom";
import axios from "axios";
import dayjs from "dayjs";
import Box from '@material-ui/core/Box';
import Container from '@material-ui/core/Container';
import { Form } from "reactstrap";
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { Select } from '@material-ui/core';
import MenuItem from '@material-ui/core/MenuItem';
import InputLabel from '@material-ui/core/InputLabel';
import FormControl from '@material-ui/core/FormControl';
import { styled } from '@material-ui/core/styles';

import { DatePicker, Space, ConfigProvider } from 'antd';
import "dayjs/plugin/updateLocale";
import "dayjs/locale/ko";
import locale from 'antd/locale/ko_KR';
import HomeIcon from '@material-ui/icons/Home';
import 'tui-grid/dist/tui-grid.css';
import Grid from '@toast-ui/react-grid';
import 'tui-pagination/dist/tui-pagination.css';

const CssSelect = styled(Select)({
  '& .MuiOutlinedInput-notchedOutline': {
    borderColor: '#59b9ea'
  },
  "& .MuiInputBase-input": {
    WebkitTextFillColor: "green",
    color: "red",
  },

});

function CholgoIndex() {
  //const gridRef = useRef();
  const [data, setData] = useState([]); //데이터 가저오기
  const [customer, setCustomer] = useState([]); // 업체selectPicker 데이터 가저오기
  const [valueSelectPicker, setValueSelectPicker] = useState(''); //selectPicker 데이터 가저오기
  const [ondatestart, setOnDateStart] = useState(); //검색시작월
  const [ondateend, setOnDateEnd] = useState(); //검색종료월
  const [gongjang, setGongjang] = useState(); //공장선택(정진,제이콥)
  const [groupby, setGroupby] = useState(); //집계방법(개별,그롭)

  //히스토리사용
  const history = useHistory();

  const getJsonCholgoLoad = async () => {
    await axios.get("/InvoiceReact/InvoiceIndex")
      .then((res) => {
        setData(res.data)
        //console.log(res);
      })
  };

  //업체찾기
  const GetSelectCustomer = async () => {
    await axios.get("/InvoiceReact/UpcheMasterIndex")
      .then((res) => {
        setCustomer(res.data)
      })
  };

  useEffect(() => {
    getJsonCholgoLoad();
    GetSelectCustomer();
    // console.log('재랜드링됨')
  }, []);

  //console.log(data);

  //new Grid option 설정부분
  const columns = (
    [
      { name: "invoice_factory", header: "세금계산서", align: "center", width: 100 },
      { name: "invoice_ma_gam_dal", header: "마감달", align: "center", width: 80 },
      { name: "invoices_u_mu_yn", header: "출고유무", align: "center", width: 80 },
      {
        name: "invoices_upche", header: "업체", align: "left", width: 150,
        filter: { type: 'text', code: 'Contains', value: 30, showClearBtn: true }
      },
      { name: "invoices_item", header: "우리품번", align: "center", width: 66 },
      {
        name: "invoices_upche_item", header: "업체품번", align: "left", width: 150,
        filter: { type: 'text', code: 'Contains', value: 30, showClearBtn: true }, className: 'gross-color',
      },
      { name: "invoices_upche_name", header: "품명", align: "left", width: 180 },
      { name: "invoices_price_pimac", header: "P단가", align: "right", width: 65 },
      { name: "invoices_danwi", header: "P단위", align: "center", width: 50 },
      { name: "invoices_price_dopo", header: "D단가", align: "right", width: 65 },
      { name: "invoice_dopo_danwi", header: "D단위", align: "center", width: 50 },
      { name: "invoices_price", header: "S단가", align: "right", width: 65 },
      {
        name: "invoices_quantity", header: "출고수량", align: "right", width: 100,
        formatter: function (ev) {
          return `${ev.value.toLocaleString('ko-KR')}`
        }
      },
      {
        name: "invoices_피막금액", header: "피막금액", align: "right", width: 100,
        formatter: function (ev) {
          return `${ev.value.toLocaleString('ko-KR')}`
        }
      },
      {
        name: "invoices_도포금액", header: "도포금액", align: "right", width: 100,
        formatter: function (ev) {
          return `${ev.value.toLocaleString('ko-KR')}`
        }
      },
      {
        name: "invoices_출고금액", header: "공급가액", align: "right", width: 110, className: 'gross-color1',
        formatter: function (ev) {
          return `${ev.value.toLocaleString('ko-KR')}`
        }
      },
      {
        name: "invoices_부가세", header: "세액", align: "right", width: 90,
        formatter: function (ev) {
          return `${ev.value.toLocaleString('ko-KR')}`
        }
      },
      {
        name: "invoices_합계금액", header: "계산서금액", align: "right", width: 110, className: 'gross-color2',
        formatter: function (ev) {
          return `${ev.value.toLocaleString('ko-KR')}`
        }
      },
      {
        name: "invoices_datetime", header: "출고일자", align: "center", width: 115,
        formatter: function (ev) {
          return `${dayjs(ev.value).format('YYYYMMDD HH:mm')}`
        }
      },
    ]
  );

  // //번호, 체크박스 설정부분
  const rowHeaders = [
    { type: 'rowNum' },
    //{type: 'checkbox'},
  ];

  const rows = data.map((row) => ({
    invoice_factory: row.invoice_factory,
    invoice_ma_gam_dal: row.invoice_ma_gam_dal,
    invoices_u_mu_yn: row.invoices_u_mu_yn,
    invoices_upche: row.invoices_upche,
    invoices_item: row.invoices_item,
    invoices_upche_item: row.invoices_upche_item,
    invoices_upche_name: row.invoices_upche_name,
    invoices_price_pimac: row.invoices_price_pimac,
    invoices_danwi: row.invoices_danwi,
    invoices_price_dopo: row.invoices_price_dopo,
    invoice_dopo_danwi: row.invoice_dopo_danwi,
    invoices_price: row.invoices_price,
    invoices_quantity: row.invoices_quantity,
    invoices_피막금액: row.invoices_피막금액,
    invoices_도포금액: row.invoices_도포금액,
    invoices_출고금액: row.invoices_출고금액,
    invoices_부가세: row.invoices_부가세,
    invoices_합계금액: row.invoices_출고금액 + row.invoices_부가세,
    invoices_datetime: row.invoices_datetime,
  }));
  //혜더 복합칼럼설정
  const header = {
    height: 60,
    complexColumns: [
      {
        header: '거래명세기준',
        name: '거래명세기준',
        childNames: ['invoice_factory']
      },
      {
        header: '피막',
        name: '피막',
        childNames: ['invoices_price_pimac', 'invoices_danwi']
      },
      {
        header: '도포',
        name: '도포',
        childNames: ['invoices_price_dopo', 'invoice_dopo_danwi']
      },
      {
        header: '세금계산서',
        name: '세금계산서',
        childNames: ['invoices_출고금액', 'invoices_부가세', 'invoices_합계금액']
      },
    ]
  }

  //그리드 합계부분
  const summary = {
    height: 30,
    position: 'bottom', // or 'top'
    columnContent: {
      invoice_factory: {
        template(summary) {
          return '<div align="center"><b>합계</b></div>';
        }
      },
      invoices_quantity: {
        template(summary) {
          return `<div align="right"><b>${Math.floor(summary.sum).toLocaleString('ko-KR')}</b></div>`; //Math.floor(summary.sum) 소솟점 버리기
        }
      },
      invoices_피막금액: {
        template(summary) {
          return `<div align="right"><b>${Math.floor(summary.sum).toLocaleString('ko-KR')}</b></div>`;
        }
      },
      invoices_도포금액: {
        template(summary) {
          return `<div align="right"><b>${Math.floor(summary.sum).toLocaleString('ko-KR')}</b></div>`;
        }
      },
      invoices_출고금액: {
        template(summary) {
          return `<div align="right"><b>${Math.floor(summary.sum).toLocaleString('ko-KR')}</b></div>`;
        }
      },
      invoices_부가세: {
        template(summary) {
          return `<div align="right"><b>${Math.floor(summary.sum).toLocaleString('ko-KR')}</b></div>`;
        }
      },
      invoices_합계금액: {
        template(summary) {
          return `<div align="right"><b>${Math.floor(summary.sum).toLocaleString('ko-KR')}<b/></div>`;
        }
      },
    },
  };

  //한글 및 테마설정--정적api 문서 확이해서 적용할것.
  const Gr = require('tui-grid');
  Gr.setLanguage('ko');
  Gr.applyTheme('striped', {
    frozenBorder: {
      // border: 'pink',
      border: '#42a5f5',
    },
    outline: {
      // border: 'blue',
      // border: '#59b9ea', //외곽테두리선
      showVerticalBorder: false, //수직선표시여부
    },
    cell: {
      normal: {
        background: 'pink',
        border: '#DCDCDC',
        showVerticalBorder: true,
        showHorizontalBorder: true,
      },

      header: {
        background: '#DCDCDC',
        border: '#C0C0C0',
        text: 'blue',
        showVerticalBorder: true,
        showHorizontalBorder: true
      },
      rowHeader: {
        background: '#DCDCDC',
        border: '#C0C0C0',
        text: 'blue',
        showVerticalBorder: true,
        showHorizontalBorder: true,
      },
      selectedRowHead: {
        background: '#e5f6ff',
        showVerticalBorder: true
      },
      summary: {
        background: '#C0C0C0',
        border: '#C0C0C0',
        text: 'blue',
        showVerticalBorder: true,
        showHorizontalBorder: true,
      },
    },

    area: {
      header: {
        border: '#59b9ea',
        background: 'silver',
        showVerticalBorder: true,
        showHorizontalBorder: true,
      },
      body: {
        border: 'red',
        background: 'white',
        showVerticalBorder: true,
        showHorizontalBorder: true,
      },
      summary: {
        border: '#59b9ea',
        background: 'silver',
        showVerticalBorder: true,
        showHorizontalBorder: true,
      },
    },
    //호버설정
    row: {
      hover: {
        background: 'silver'
      }
    },
  });


  //selectPicker 업체 데이타뿌리기
  const selectData = customer.map(
    item => ({ label: item.upche_sanghoupche_sangho, value: item.upche_code })
  );

  ////폼 전송실행 함수(조건찾기)
  const handleSubmit = (event) => {
    event.preventDefault();
    const evValue = new FormData(event.currentTarget);
    const valueCustomer = valueSelectPicker.value ? valueSelectPicker.value : "%";     //업체코드
    const valueGongjang = gongjang ? gongjang : '%';   //공장
    const valueUlisabun = evValue.get("ulisabun") ? evValue.get("ulisabun") : '%'; //우리품번
    const valueCusitem = evValue.get("cusitem") ? evValue.get("cusitem") : '%';   //업체품번
    const valueInvoicedateStart = ondatestart ? dayjs(ondatestart).format('YYYYMM') : '%'  //등록검색시작일
    const valueInvoicedateEnd = ondateend ? dayjs(ondateend).format('YYYYMM') : '%'  //등록검색종료일
    const valueGroupby = groupby ? groupby : '';   //공장
    // console.log(valueCustomer, valueGongjang, valueUlisabun, valueCusitem, valueInvoicedateStart, valueInvoicedateEnd);
    // console.log("업체코드:", valueCustomer);
    axios.get(`/InvoiceReact/InvoiceIndex?valueCustomer=${valueCustomer}&valueGongjang=${valueGongjang}&valueUlisabun=${valueUlisabun}&valueCusitem=${valueCusitem}&valueInvoicedateStart=${valueInvoicedateStart}&valueInvoicedateEnd=${valueInvoicedateEnd}&valueGroupby=${valueGroupby}`)
      .then((res) => setData(res.data));
  };

  //날짜범위등록시작일
  const onDateStartChangeHandle = (dates, dateStrings) => {
    if (dates) {
      setOnDateStart(dateStrings)
    } else {
      setOnDateStart()
    }
  };
  //날짜범위등록종료일
  const onDateEndChangeHandle = (dates, dateStrings) => {
    if (dates) {
      setOnDateEnd(dateStrings)
    } else {
      setOnDateEnd()
    }
  };
  //공장선택
  let gongjangHandle = (e) => {
    e.preventDefault();
    setGongjang(e.target.value);
  }
  //공장선택
  let groupbyHandle = (e) => {
    e.preventDefault();
    setGroupby(e.target.value);
  }

  return (
    <>
      <div style={{ textAlign: "center" }}>
        {/* 폼입력자료 전송 */}
        <Box sx={{ ml: 3 }}>
          <h3 style={{ paddingBottom: "10px", marginTop: "20px", textAlign: "center", color: "blue" }}>세금계산서[거래명세표기준]</h3>
          <Form onSubmit={handleSubmit} style={{ marginBottom: "10px" }}>
            <div className="input-group mb-12">
              <FormControl variant="outlined" style={{ minWidth: 150, marginRight: '2px' }} size="small">
                <InputLabel >공장</InputLabel>
                <CssSelect
                  variant="outlined"
                  value={gongjang ? gongjang : ''}
                  onChange={gongjangHandle}
                  label="공장"
                >
                  <MenuItem value=''><em>선택없음</em></MenuItem>
                  <MenuItem value={'정진P&G'}>정진P&G</MenuItem>
                  <MenuItem value={'(주)제이콥'}>(주)제이콥</MenuItem>
                </CssSelect>
              </FormControl>
              <Autocomplete
                options={selectData}
                getOptionLabel={(option) => option.label || ""}
                size="small"
                style={{ width: 200, marginRight: 3 }}
                value={valueSelectPicker ? valueSelectPicker : setValueSelectPicker('%')}
                onChange={(event, newValue) => {
                  setValueSelectPicker(newValue);
                }}
                renderInput={(params) => <TextField {...params} label="업체" variant="outlined" />}
              />
              <TextField
                style={{ width: 130, marginRight: "2px", float: "center" }}
                variant="outlined"
                size="small"
                label="우리품번"
                name="ulisabun"
                autoComplete="ulisabun"
              />
              <TextField
                style={{ width: 130, marginRight: "2px", float: "center" }}
                variant="outlined"
                size="small"
                label="업체품번"
                name="cusitem"
                autoComplete="cusitem"
                autoFocus
              />

              <ConfigProvider locale={locale}>
                <Space direction="vertical" size={12}>
                  <DatePicker
                    style={{
                      height: 38,
                      borderRadius: 4,
                      marginRight: 2,
                      width: "120px",
                    }}
                    picker="month"
                    format="YYYYMM"
                    placeholder="시작마감월"
                    onChange={onDateStartChangeHandle} //날짜범위시작일
                  />
                </Space>
              </ConfigProvider>
              <ConfigProvider locale={locale}>
                <Space direction="vertical" size={12}>
                  <DatePicker
                    style={{
                      height: 38,
                      borderRadius: 4,
                      marginRight: 2,
                      width: "120px",
                    }}
                    picker="month"
                    format="YYYYMM"
                    placeholder="종료마감월"
                    onChange={onDateEndChangeHandle} //날짜범위종료일
                  />
                </Space>
              </ConfigProvider>
              {/* 집계방법 */}
              <FormControl variant="outlined" style={{ minWidth: 120, marginRight: '4px' }} size="small">
                <InputLabel >집계방법</InputLabel>
                <Select
                  variant="outlined"
                  value={groupby ? groupby : ''}
                  onChange={groupbyHandle}
                  label="집계방법"
                >
                  <MenuItem value=''><em>없음</em></MenuItem>
                  <MenuItem value={'개별'}>개별</MenuItem>
                  <MenuItem value={'품번'}>품번</MenuItem>
                  <MenuItem value={'그룹'}>그룹</MenuItem>
                </Select>
              </FormControl>
              <Button
                type="submit"
                variant="contained"
                style={{
                  background: '#0277bd',
                  color: 'white',
                  height: 36,
                  width: 120,
                  marginRight: 3,
                  float: "center",
                }}
              >
                <i className="fa-solid fa-magnifying-glass" style={{ fontSize: '16px' }}></i>
                조회
              </Button>
              <Button
                id="homemove"
                variant="contained"
                startIcon={<HomeIcon />}
                style={{
                  background: '#004d40',
                  color: 'white',
                  height: 36,
                  width: 120,
                  float: "center",
                }}
                onClick={() => {
                  // window.location.href = "/home/index";
                  history.goBack();
                }}
              >
                홈이동
              </Button>
            </div>
          </Form>
        </Box>
      </div>
      <Container maxWidth="xl">
        <Box style={{ border: "1px solid", borderColor: "#42a5f5", borderRadius: "1px" }}>
          <Grid
            columns={columns}
            data={rows}
            header={header}
            summary={summary}
            //scrollX={false}
            scrollY={false}
            rowHeight={"auto"}
            minRowHeight={30}
            //bodyHeight={650}
            bodyHeight={"auto"}
            heightResizable={true}
            //columnOptions= {{resizable: true}} //컬럼마우스조절가능
            //rowHeaders={['rowNum','checkbox']}
            virtualScrolling={true}
            rowHeaders={rowHeaders}
            usageStatistics={false} //전 세계적으로 TOAST UI Grid가 얼마나 널리 사용되고 있는지 파악 사용
            pageOptions={{ useClient: true, perPage: 18 }} // front에서만 페이징 하는 속성
            //pageOptions= {{perPage: 20}}
            //oneTimeBindingProps={['data', 'columns']} //무조건 재랜더링 방지
            columnOptions={{
              minWidth: 50,
              resizable: true,
              frozenCount: 3,
              frozenBorderWidth: 1,
            }}
          />
        </Box>
      </Container>
    </>
  )
}

export default CholgoIndex